module.exports = __webpack_public_path__ + "static/Graphik-Medium-Web-ef813fdd13bb68522cb4e9317f121f25.woff";